import React, { Component } from 'react'
import Selector from '../../../components/global/selector/Selector'

class SelectorContainer extends Component {
    constructor() {
        super()
        this.state = {}
    }

    handleChangeSelect = e => {
        this.props.onChangeSelect(e)
    }

    render() {
        const { selected, options} = this.props
        return (
            <Selector selected={selected} options={options} onChangeSelect={this.handleChangeSelect} />
        )
    }
}
export default SelectorContainer

